/*
  Ezra corporate gifting: keep corporate cart lines on the right price tier.

  Corporate products (handle ends in "-corporate") have a "Corporate tier" option
  whose values start with the tier's minimum quantity, e.g. "10-24 units", "25-49 units".
  Each tier variant carries its own price, so cart, drawer and checkout charge it as-is.
  When a shopper changes a corporate line's quantity in the cart drawer or cart page and
  crosses a tier boundary, this swaps the line to the matching tier variant.
*/
(function () {
  if (window.__ezraCorporateCart) return;
  window.__ezraCorporateCart = true;

  var SUFFIX = '-corporate';
  var TIER_OPTION = 'Corporate tier';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var products = {};
  var running = false;

  function json(url, body) {
    var opts = { headers: { 'Accept': 'application/json', 'X-Ezra-Corporate': '1' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(root + url, opts).then(function (r) { return r.json(); });
  }

  function product(handle) {
    if (!products[handle]) products[handle] = json('products/' + handle + '.js');
    return products[handle];
  }

  function tierIndex(values, qty) {
    var idx = 0;
    values.forEach(function (v, i) { if (qty >= parseInt(v, 10)) idx = i; });
    return idx;
  }

  function refresh() {
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
  }

  function check() {
    if (running) return Promise.resolve();
    running = true;
    return json('cart.js')
      .then(function (cart) {
        var lines = cart.items.filter(function (i) { return i.handle && i.handle.slice(-SUFFIX.length) === SUFFIX; });
        return Promise.all(lines.map(function (line) {
          return product(line.handle).then(function (p) {
            var pos = p.options.findIndex(function (o) { return (o.name || o) === TIER_OPTION; });
            if (pos < 0) return null;
            var values = p.options[pos].values;
            var want = values[tierIndex(values, line.quantity)];
            if (line.variant_options[pos] === want) return null;
            var target = line.variant_options.slice();
            target[pos] = want;
            var v = p.variants.find(function (x) {
              return x.options.every(function (o, k) { return o === target[k]; });
            });
            return v ? { key: line.key, id: v.id, quantity: line.quantity, properties: line.properties || {} } : null;
          });
        }));
      })
      .then(function (fixes) {
        fixes = (fixes || []).filter(Boolean);
        if (!fixes.length) return;
        var updates = {};
        fixes.forEach(function (f) { updates[f.key] = 0; });
        return json('cart/update.js', { updates: updates })
          .then(function () {
            return json('cart/add.js', { items: fixes.map(function (f) { return { id: f.id, quantity: f.quantity, properties: f.properties }; }) });
          })
          .then(refresh);
      })
      .catch(function (e) { console.warn('[ezra-corporate-cart]', e); })
      .then(function () { running = false; });
  }

  // Re-check after any cart change the theme makes.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var ours = init && init.headers && init.headers['X-Ezra-Corporate'];
    var p = nativeFetch(input, init);
    if (!ours && /\/cart\/(change|update)/.test(url)) {
      p.then(function () { setTimeout(check, 50); }, function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
